import React from "react";
import { useState, useEffect } from "react";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import { makeStyles } from "@material-ui/core/styles";
import Navbar from "./navbarAccountSettings";
import AccountInformation from "./accountInformation";
import Billing from "./billing";
import UserManagement from "./userManagement";
import Pricing from "./pricing";
import ToolSettings from "./toolSettings";
import VersionTransfer from "./versionTransfer";
import UpdateDatabase from "./updateDatabase";
import SuperAdminPanel from "./superAdminPanel";
import RuntimeBasesPanel from "./runtimeBasesPanel";

const useStyles = makeStyles(() => ({
  paper: {
    backgroundColor: "#404040",
    top: "46px"
  }
}));

/**
 * @param props.createSnackbar
 * @param props.userPermissions
 */
export default function dialogAccountSettings(props) {
  const classes = useStyles();
  const [isOpen, setOpen] = useState(false);
  const [selectedPage, setSelectedPage] = useState(0);

  useEffect(() => {
    if (props.isAccountInfoVisible) {
      toggleDrawer(props.isAccountInfoVisible);
    }
  }, [props.isAccountInfoVisible]);

  const toggleDrawer = (isOpen) => {
    setOpen(isOpen);
    props.setIsAccountInfoVisible(isOpen);
    if (isOpen && props.initialSelectedPage !== undefined) {
      setSelectedPage(props.initialSelectedPage);
    }
  };

  const list = () => (
    <div id="dialogAccountSettings" role="presentation" onKeyDown={() => {}}>
      <Navbar
        setSelectedPage={setSelectedPage}
        userRole={props.userRole}
        canManageRuntimeBases={props.canManageRuntimeBases}
        canGrantPe3dGames={props.canGrantPe3dGames}
        canGrantBasesToCompanies={props.canGrantBasesToCompanies}
        userPermissions={props.userPermissions}
        appEnv={props.appEnv}
        createSnackbar={props.createSnackbar}
        selectedVersion={props.selectedVersion}
        selectedBase={props.selectedBase}
        setIsVersionBeingUpdatedFalse={props.setIsVersionBeingUpdatedFalse}
      />
      {selectedPage === 0 && (
        <AccountInformation
          userCompany={props.userCompany}
          userName={props.userName}
          userRole={props.userRole}
          switchTargets={props.switchTargets}
          numberOfBases={props.numberOfBases}
          plans={props.plans}
          createSnackbar={props.createSnackbar}
          getPlanIndex={props.getPlanIndex}
        />
      )}
      {selectedPage === 1 && <Billing userCompany={props.userCompany} createSnackbar={props.createSnackbar} />}
      {selectedPage === 2 && (
        <UserManagement
          userCompany={props.userCompany}
          userName={props.userName}
          createSnackbar={props.createSnackbar}
        />
      )}
      {selectedPage === 3 && <Pricing plans={props.plans} classes={props.classes} />}
      {selectedPage === 4 && <ToolSettings userCompany={props.userCompany} />}
      {selectedPage === 5 && (
        <VersionTransfer
          selectedVersion={props.selectedVersion}
          selectedGame={props.selectedGame}
          selectedBase={props.selectedBase}
          games={props.games}
        />
      )}
      {selectedPage === 6 && (
        <UpdateDatabase selectedBase={props.selectedBase} appEnv={props.appEnv} onClose={() => toggleDrawer(false)} />
      )}
      {selectedPage === 7 && <SuperAdminPanel createSnackbar={props.createSnackbar} plans={props.plans} onRuntimeChanged={props.onRuntimeChanged} />}
      {selectedPage === 8 && (
        <RuntimeBasesPanel
          createSnackbar={props.createSnackbar}
          canDelete={false}
          canCreate={props.canManageRuntimeBases === true}
          canGrantGames={props.canGrantPe3dGames === true}
          onRuntimeChanged={props.onRuntimeChanged}
        />
      )}
      {selectedPage === 9 && (
        <SuperAdminPanel grantOnly createSnackbar={props.createSnackbar} switchTargets={props.switchTargets} />
      )}
    </div>
  );

  return (
    <div>
      {
        <React.Fragment key={"bottom"}>
          <SwipeableDrawer
            anchor={"bottom"}
            open={isOpen}
            onClose={() => toggleDrawer(false)}
            onOpen={() => toggleDrawer(true)}
            classes={{ paper: classes.paper }}
          >
            {list()}
          </SwipeableDrawer>
        </React.Fragment>
      }
    </div>
  );
}
